import { prepareModelForStore } from '@editor/stores/modelStore/utils'
import { getRequest } from 'src/state/utils'

export const getModel: RequestTypeVariable = {
  getKey: (id: string) => ['getModel', id],
  request: async (id: string): Promise<PlanarModel> => {
    const { data } = await getRequest<PlanarModelApiResponse>({
      url: `/projects/${id}/planar-model`,
    })

    if (!data) {
      throw new Error('Planar model response was empty')
    }

    return prepareModelForStore(data)
  },
}
